import { handleActions } from "redux-actions";
import { MUTE_TOGGLE } from "./actions";

const initialState = {
  mute: false
};

// Sets the value or negates/toggles the current value
const toggleOrSet = (value, current) =>
  Boolean(value !== undefined ? value : !current);

export default handleActions(
  {
    [MUTE_TOGGLE]: (state, { payload }) => ({
      ...state,
      mute: toggleOrSet(payload, state.mute)
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/sound/reducer.js